import React, { useCallback, useEffect, useState } from 'react'
import ApplicationPaymentFormModal from './ApplicationPaymentFormModal'
import { useDispatch } from 'react-redux'
import { fetchPaymentByIdAction, updatePaymentAction } from '../../../store/payment'
import { message } from 'antd'

const messageKey = 'edit_payment'

const EditApplicationPaymentModal = ({ showModal, paymentId, onFinish, onCancel }) => {
  const dispatch = useDispatch()

  let [payment, setPayment] = useState(null)

  const fetchPayment = useCallback(
    async (id) => {
      const response = await dispatch(fetchPaymentByIdAction(id)).unwrap()
      if (response.data) {
        const { id, attributes } = response.data
        setPayment({ id, ...attributes })
      }
    },
    [dispatch]
  )

  useEffect(() => {
    if (paymentId) {
      fetchPayment(paymentId)
    }
  }, [paymentId])

  const onFinishAction = useCallback(
    async ({ description, is_full, paid, pay_date }) => {
      await dispatch(updatePaymentAction({ id: paymentId, description, is_full, paid, pay_date })).unwrap()
      message.success({
        key: messageKey,
        content: `Платёж '${paymentId}' обновлен успешно`,
      })
      onFinish()
    },
    [paymentId, dispatch]
  )

  const onErrorAction = useCallback(({ name, status, message: errorMessage }) => {
    message.error({
      key: messageKey,
      content: `Ошибка (${name}, статус: ${status}): '${errorMessage}' `,
    })
  }, [])

  return (
    <ApplicationPaymentFormModal
      showModal={showModal}
      payment={payment}
      onFinish={onFinishAction}
      onError={onErrorAction}
      onCancel={onCancel}
    />
  )
}

export default EditApplicationPaymentModal
